import * as types from './types';

/**
 * Obtiene los datos iniciales del paso de selección de plan:
 * sucursales, usuarios permitidos y créditos disponibles.
 * @param {string | number} postingId - ID del aviso.
 * @returns {Object}
 */
const getInitialsValues = postingId => {
  return {
    type: types.GET_INITIALS_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/STEP_PLAN_SELECTION/${postingId}`,
      method: 'GET'
    }
  };
};

/**
 * Nos devuelve los planes disponibles para una sucursal y los usuarios correspondientes para esa sucursal.
 * @param {string | number} postingId - ID del aviso actual.
 * @param {string | number} branchId - ID de la sucursal seleccionada.
 * @returns {Object}
 */
const getCreditsOfBranch = (postingId, branchId) => {
  return {
    type: types.GET_CREDITS_OF_BRANCH,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/credits/${postingId}/${branchId}`,
      method: 'GET'
    }
  };
};

/**
 * Actualiza el responsable asignado a un aviso.
 * @param {string | number} postingId - ID del aviso.
 * @param {string | number} userId - ID del nuevo responsable.
 * @returns {Object}
 */
const updatePostingResponsible = (postingId, userId) => {
  return {
    type: types.UPDATE_RESPONSIBLE,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/updatePostingResponsible?postingId=${postingId}&userId=${userId}`,
      method: 'PUT'
    }
  };
};

/**
 * Cambia la sucursal (publisher) asignada al aviso.
 * @param {string | number} postingId - ID del aviso.
 * @param {string | number} branch_id_origen - ID de la sucursal actual.
 * @param {string | number} branch_id_destino - ID de la nueva sucursal.
 * @returns {Object}
 */
const updatePostingBranch = (postingId, branch_id_origen, branch_id_destino) => {
  return {
    type: types.UPDATE_BRANCH,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/changePostingPublisher`,
      body: {
        posting_id: postingId,
        publisher_id_origen: branch_id_origen,
        publisher_id_destino: branch_id_destino
      },
      method: 'POST'
    }
  };
};

/**
 * Actualiza el plan seleccionado
 * @param {string | number} planId - ID del plan seleccionado.
 * @returns {Object}
 */
const updateSelectedPlan = planId => ({
  type: types.UPDATE_SELECTED_PLAN,
  payload: {
    planId
  }
});

/**
 * Actualiza  el responsable seleccionado
 * @param {string | number} responsibleId - ID del responsable seleccionado.
 * @returns {Object}
 */
const updateSelectedResponsible = responsibleId => ({
  type: types.UPDATE_SELECTED_RESPONSIBLE,
  payload: {
    responsible: responsibleId
  }
});

/**
 * Actualiza la sucursal seleccionada
 * @param {string | number} branchId - ID de la sucursal seleccionada.
 * @returns {Object}
 */
const updateSelectedBranch = branchId => ({
  type: types.UPDATE_SELECTED_BRANCH,
  payload: {
    branchId
  }
});

/**
 * Actualiza el porcentaje de comisión compartida
 * @param {number} commissionShare - Porcentaje de comisión compartida.
 * @returns {Object}
 */
const updateCommissionShare = commissionShare => ({
  type: types.UPDATE_COMMISSION_SHARE,
  payload: {
    commissionShare
  }
});

const resetInfo = () => ({
  type: types.RESET_INFO
});

export {
  getInitialsValues,
  getCreditsOfBranch,
  updatePostingResponsible,
  updatePostingBranch,
  updateSelectedPlan,
  updateSelectedResponsible,
  updateSelectedBranch,
  updateCommissionShare,
  resetInfo
};
